// @ts-ignore
export const getModal = (state) => state.utilsStore.modal
// @ts-ignore
export const getInfoModal = (state) => state.utilsStore.infoModal
// @ts-ignore
export const getErrorModal = (state) => state.utilsStore.errorModal
